import { render, staticRenderFns } from "./kindList.vue?vue&type=template&id=53940824&scoped=true"
import script from "./kindList.vue?vue&type=script&lang=js"
export * from "./kindList.vue?vue&type=script&lang=js"
import style0 from "./kindList.vue?vue&type=style&index=0&id=53940824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53940824",
  null
  
)

export default component.exports